var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.panelClickOutside,
          expression: "panelClickOutside",
        },
      ],
      attrs: { id: "vue-repost" },
    },
    [
      _c(
        "div",
        { staticClass: "u-width-full u-cursor-pointer" },
        [
          !_vm.standalone
            ? _c("div", { staticClass: "ugc__reposted" }, [
                _c("div", { staticClass: "ugc__action last u-width-full" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ugc__action-community u-cursor-pointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.panelOpen.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.repostedItems.length > 0
                        ? _c("div", { staticClass: "ugc__repost-selected" }, [
                            _c("img", {
                              staticClass: "ugc__repost-community-icon",
                              attrs: {
                                src: _vm.$simpleStore.transformImageWithCloudfront(
                                  44,
                                  44,
                                  _vm.repostedItems[0].image,
                                  _vm.$root
                                ),
                                alt: _vm.repostedItems[0].name,
                                width: "44",
                                height: "44",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "ugc__repost-arrows",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "18",
                                  height: "13",
                                  viewBox: "0 0 22 16",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1 4V6C1 9.31371 3.68629 12 7 12H11M21 12V10C21 6.68629 18.3137 4 15 4H11",
                                    stroke: "white",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M14 1L11 4L14 7",
                                    stroke: "white",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M9 15L12 12L9 9",
                                    stroke: "white",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _c("a", { attrs: { href: "#" } }, [
                            _c("img", {
                              attrs: {
                                src: _vm.$cdn("/img2.0/icons/repost.svg"),
                                alt: "Repost",
                                width: "44",
                                height: "44",
                              },
                            }),
                          ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ugc__text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.repostedItems.length > 0
                              ? "Reposting to " + _vm.repostedItems[0].name
                              : "Repost to a community"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.repostedItems.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "u-cursor-pointer",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.clearRepost.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.$cdn("/img/ui/icon-remove-post.svg"),
                              alt: "Remove repost",
                              width: "14",
                              height: "14",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "hidden",
                    id: "getRepostedCommunities",
                    value: "",
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.modal
            ? _c(
                "Menu",
                {
                  attrs: {
                    "show-menu": _vm.open,
                    "close-event": _vm.modalCloseEvent,
                    top: true,
                    "scroll-class": "menu__content--scroll",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "menu__title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.standalone && _vm.hasReposted
                                ? "Your reposts"
                                : "Repost to a community"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.standalone && _vm.hasReposted
                        ? _c(
                            "div",
                            { staticClass: "menu__items" },
                            [
                              _vm._l(_vm.myReposts, function (entry) {
                                return _c(
                                  "div",
                                  {
                                    key: entry.community_id,
                                    staticClass: "items",
                                  },
                                  [
                                    entry.image
                                      ? _c("img", {
                                          staticClass: "u-radius-4",
                                          attrs: {
                                            src: _vm.$simpleStore.transformImageWithCloudfront(
                                              112,
                                              112,
                                              "img/communities/" +
                                                entry.community_id +
                                                "/" +
                                                entry.image,
                                              _vm.$root
                                            ),
                                            alt: "",
                                            width: "50",
                                            height: "50",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "items__details" },
                                      [_c("p", [_vm._v(_vm._s(entry.name))])]
                                    ),
                                    _vm._v(" "),
                                    !_vm.confirmRemove ||
                                    _vm.confirmCommunity.community_id !==
                                      entry.community_id
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "items__action",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.confirmRemoveRepost(
                                                  entry
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            Remove\n                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.confirmRemove
                                ? _c("div", { staticClass: "menu__confirm" }, [
                                    _c("p", [
                                      _vm._v("Remove repost from "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.confirmCommunity.name)
                                        ),
                                      ]),
                                      _vm._v("?"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "u-flex u-gap-2 u-m-t2" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "c-btn c-btn--blue new small",
                                            attrs: {
                                              disabled: _vm.removingRepost,
                                            },
                                            on: {
                                              click: _vm.executeRemoveRepost,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.removingRepost
                                                    ? "Removing…"
                                                    : "Yes, remove"
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "c-btn3 new small",
                                            attrs: {
                                              disabled: _vm.removingRepost,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.confirmRemove = false
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Cancel\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          )
                        : [
                            _vm.noCommunitiesAvailable
                              ? _c("div", { staticClass: "menu__items" }, [
                                  _c(
                                    "p",
                                    { staticClass: "u-color-black u-bold" },
                                    [_vm._v("No communities available")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "u-color-grey2 u-text-small",
                                    },
                                    [
                                      _vm._v(
                                        "You need to be a member of at least one other community to repost this article."
                                      ),
                                    ]
                                  ),
                                ])
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "menu__search followers" },
                                    [
                                      _c("div", { staticClass: "search" }, [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              "search__icon",
                                              {
                                                "search__icon--loading":
                                                  _vm.loadingCommunities,
                                              },
                                            ],
                                            attrs: { "aria-hidden": "true" },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "search__icon-glass",
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  viewBox: "0 0 16 16",
                                                  fill: "none",
                                                },
                                              },
                                              [
                                                _c("circle", {
                                                  attrs: {
                                                    cx: "7",
                                                    cy: "7",
                                                    r: "5.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.5",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("line", {
                                                  attrs: {
                                                    x1: "11.5",
                                                    y1: "11.5",
                                                    x2: "15",
                                                    y2: "15",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.5",
                                                    "stroke-linecap": "round",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "search__icon-spinner",
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  viewBox: "0 0 16 16",
                                                  fill: "none",
                                                },
                                              },
                                              [
                                                _c("circle", {
                                                  attrs: {
                                                    cx: "7",
                                                    cy: "7",
                                                    r: "5.5",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.5",
                                                    "stroke-linecap": "round",
                                                    "stroke-dasharray": "26 9",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.search,
                                              expression: "search",
                                            },
                                          ],
                                          staticClass: "search",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Search communities",
                                          },
                                          domProps: { value: _vm.search },
                                          on: {
                                            keyup: _vm.filterReposts,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.search = $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              "search__clear",
                                              _vm.search.length > 0
                                                ? "search__active"
                                                : "",
                                            ],
                                            attrs: {
                                              "aria-label": "Clear search",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.clearSearch.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "14",
                                                  height: "14",
                                                  viewBox: "0 0 14 14",
                                                  fill: "none",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M1 1L13 13M13 1L1 13",
                                                    stroke: "currentColor",
                                                    "stroke-width": "1.5",
                                                    "stroke-linecap": "round",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "menu__items" },
                                    _vm._l(
                                      _vm.repostCommunities,
                                      function (repost, index) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass: "items",
                                            class: {
                                              "u-hidden": repost.isHidden,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.communitySelect(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "u-radius-4",
                                              attrs: {
                                                src: _vm.$simpleStore.transformImageWithCloudfront(
                                                  112,
                                                  112,
                                                  repost.image,
                                                  _vm.$root
                                                ),
                                                alt: "",
                                                width: "50",
                                                height: "50",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "items__details" },
                                              [
                                                _c("p", [
                                                  _vm._v(_vm._s(repost.name)),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "items__action",
                                                attrs: {
                                                  disabled: repost.reposted,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      repost.reposted
                                                        ? "Reposted"
                                                        : "Repost"
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                          ],
                    ],
                    2
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "c-panel c-panel--repost",
                  class: { open: _vm.open },
                },
                [
                  _c("div", { staticClass: "c-panel__head" }, [
                    _c("div", { staticClass: "c-panel__logo" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.$cdn(
                            _vm.$root.brand.key === "dyadey"
                              ? "/img/logo/dyadey-small.svg"
                              : _vm.$root.brand.logo_symbol
                          ),
                          alt: _vm.$root.brand.name + " Logo",
                          width: "27",
                          height: "18",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "u-color-black" }, [
                        _vm._v("Repost"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "c-panel__close",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.panelClose.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.$cdn("/img/ui/icon-close-black.svg"),
                            alt: "Close Icon",
                            width: "25",
                            height: "25",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-panel__content c-panel__content--full",
                      on: { scroll: _vm.onCommunitiesScroll },
                    },
                    [
                      _vm.standalone && _vm.hasReposted
                        ? [
                            _c(
                              "p",
                              { staticClass: "u-color-black u-bold u-p-b2" },
                              [_vm._v("Already reposted")]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "u-m-b3" }, [
                              _vm._v(
                                "You have reposted this article to the following community."
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.myReposts, function (entry) {
                              return _c(
                                "div",
                                {
                                  key: entry.community_id,
                                  staticClass: "c-panel__community-wrap",
                                },
                                [
                                  _c("div", { staticClass: "u-width-full" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "c-panel__community u-flex u-flex-justify-between",
                                        attrs: { href: "#0" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-panel__community-details u-flex u-flex-align-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "c-panel__members",
                                              },
                                              [
                                                entry.image
                                                  ? _c("img", {
                                                      staticClass:
                                                        "c-panel__community-icon u-radius-4",
                                                      attrs: {
                                                        src: _vm.$simpleStore.transformImageWithCloudfront(
                                                          112,
                                                          112,
                                                          "img/communities/" +
                                                            entry.community_id +
                                                            "/" +
                                                            entry.image,
                                                          _vm.$root
                                                        ),
                                                        alt: "",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-panel__community-details",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "u-color-black",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(entry.name)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.confirmRemove ||
                                        _vm.confirmCommunity.community_id !==
                                          entry.community_id
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "c-btn c-btn--blue new small",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.confirmRemoveRepost(
                                                      entry
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                Remove repost\n                            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.confirmRemove &&
                                  _vm.confirmCommunity.community_id ===
                                    entry.community_id
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-panel__confirm u-m-t2",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "u-color-black u-text-small u-m-b2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                Remove this repost from "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.confirmCommunity.name
                                                  )
                                                ),
                                              ]),
                                              _vm._v(
                                                "? This cannot be undone.\n                            "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "u-flex u-gap-2" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "c-btn c-btn--blue new small",
                                                  attrs: {
                                                    disabled:
                                                      _vm.removingRepost,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.executeRemoveRepost,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.removingRepost
                                                          ? "Removing…"
                                                          : "Yes, remove"
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "c-btn3 new small",
                                                  attrs: {
                                                    disabled:
                                                      _vm.removingRepost,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.confirmRemove = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Cancel\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                          ]
                        : [
                            _c(
                              "p",
                              { staticClass: "u-color-black u-bold u-p-b2" },
                              [
                                _vm._v(
                                  "\n                        Repost to one other community\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "u-m-b3" }, [
                              _vm._v(
                                "Share this article with members of another community you belong to."
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.noCommunitiesAvailable
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "c-panel__community-noresults",
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "u-color-black u-bold" },
                                      [_vm._v("No communities available")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "u-color-grey2 u-text-small",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            You need to be a member of at least one other community to repost this article.\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.search,
                                        expression: "search",
                                      },
                                    ],
                                    staticClass:
                                      "c-textbox c-textbox--grey u-width-full u-m-b3",
                                    attrs: {
                                      type: "text",
                                      name: "repost-filter",
                                      id: "repost-filter",
                                      placeholder: "Search communities...",
                                    },
                                    domProps: { value: _vm.search },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.search = $event.target.value
                                        },
                                        _vm.filterReposts,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.repostCommunities,
                                    function (repost, index) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-panel__community-wrap",
                                          class: {
                                            "u-hidden": repost.isHidden,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "u-width-full",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.communitySelect(
                                                    $event,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "c-panel__community u-flex u-flex-justify-between",
                                                  class: {
                                                    reposted: repost.reposted,
                                                  },
                                                  attrs: { href: "#0" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      !_vm.standalone &&
                                                        _vm.$set(
                                                          repost,
                                                          "reposted",
                                                          !repost.reposted
                                                        )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-panel__community-details u-flex u-flex-align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-panel__members",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "c-panel__community-icon u-radius-4",
                                                            attrs: {
                                                              src: _vm.$simpleStore.transformImageWithCloudfront(
                                                                112,
                                                                112,
                                                                repost.image,
                                                                _vm.$root
                                                              ),
                                                              alt: "",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "c-panel__community-details",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "u-color-black",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      repost.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "c-panel__members",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm.$cdn(
                                                                        "/img/icons/icon-members.svg"
                                                                      ),
                                                                      alt: "Members Icon",
                                                                      width:
                                                                        "24",
                                                                      height:
                                                                        "16",
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "member",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Members " +
                                                                          _vm._s(
                                                                            repost.members_count
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.standalone
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "c-btn new small",
                                                          attrs: {
                                                            disabled:
                                                              repost.reposted,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.communitySelect(
                                                                $event,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                repost.reposted
                                                                  ? "Reposted"
                                                                  : "Repost"
                                                              ) +
                                                              "\n                                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          repost.joined == null
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-btn__panel-join",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return $event.target.classList.toggle(
                                                        "fade"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Join")]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.showSuggest
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-panel__community-noresults",
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "u-color-text u-bold",
                                              },
                                              [_vm._v("Suggest a community")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "u-color-grey2 u-text-small",
                                              },
                                              [
                                                _vm._v(
                                                  "Can't find the community you are looking for? Why not suggest a community?"
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("button", {
                                              staticClass:
                                                "c-panel__community-new",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.$simpleStore.suggest(
                                                    _vm.$router,
                                                    "Create Post"
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                          ],
                    ],
                    2
                  ),
                ]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }